export function getOpenBankingInstitutionsV1(send) {
  return (...args) =>
    send(
      {
        path: '/v1/openbanking/institutions',
        pathParameters: {},
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
